import { useState, useEffect, useRef } from "react";
import { Home, Star, X } from "lucide-react";
export default function BrandsWeWorkWith() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const row1 = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Home-Page_Boart-Longyear.jpg",
    alt: "Boart Longyear"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Picture10.jpg",
    alt: "Carl Hamm"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Homepage_Mastercool.jpg",
    alt: "Mastercool"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Picture4.jpg",
    alt: "Putzmeister"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Homepage_Starweld.jpg",
    alt: "Star Weld"
  }];
  const row2 = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Lincoln-Electrical.jpg",
    alt: "Lincoln Electric"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Homepage_Vision-X.jpg",
    alt: "Vision X Global Lighting Systems"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Picture2.jpg",
    alt: "Weitkowitz Intercable Group"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Hella_dbbccb07a5.jpg",
    alt: "Hella"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/Picture11.jpg",
    alt: "Intercable"
  }];
  return;
}